import CookiesService from '@src/services/cookies.service';
import WindowService from '@src/services/window.service';

export const EXPERIMENT_OVERRIDE_PREFIX = 'experiment_';
export const EXPERIMENT_NAME_PARAM = 'experimentName';
export const EXPERIMENT_VARIATION_PARAM = 'experimentVariation';
export const CONTROL_VARIATION_NAME = 'CONTROL';

export function saveExperimentOverridesToCookies(
  newCookies: Record<string, string>,
) {
  const currentCookies = CookiesService.getAllCookiesWithPrefix(
    EXPERIMENT_OVERRIDE_PREFIX,
  );

  const newCookiesWithPrefix = Object.keys(newCookies).reduce<
    Record<string, string>
  >(
    (accumulator, key) => (
      key.startsWith(EXPERIMENT_OVERRIDE_PREFIX)
        ? (accumulator[`${key}`] = newCookies[key])
        : (accumulator[`${EXPERIMENT_OVERRIDE_PREFIX}${key}`] =
            newCookies[key]),
      accumulator
    ),
    {},
  );

  const newCookiesWithPrefixKeys = Object.keys(newCookies);

  const cookiesToUpdate = Object.keys(currentCookies).reduce<
    Record<string, string>
  >((accumulator, key) => {
    if (newCookiesWithPrefixKeys.includes(key)) {
      accumulator[key] = currentCookies[key];
    }
    return accumulator;
  }, {});

  const updatedCookies = {
    ...cookiesToUpdate,
    ...newCookiesWithPrefix,
  };

  Object.entries(updatedCookies).forEach(([name, value]) => {
    CookiesService.setCookie({
      name,
      value,
      path: '/',
    });
  });
}

export function getExperimentOverridesFromCookies(): Record<string, string> {
  const cookies = CookiesService.getAllCookiesWithPrefix(
    EXPERIMENT_OVERRIDE_PREFIX,
  );

  if (cookies) {
    return Object.fromEntries(
      Object.entries(cookies).map(([key, value]) => [
        `${key.slice(EXPERIMENT_OVERRIDE_PREFIX.length)}`,
        value,
      ]),
    ) as Record<string, string>;
  }

  return {};
}

export function getExperimentOverridesFromUrl(): Record<string, string> {
  const experimentNames = WindowService.getQueryParamValues(
    EXPERIMENT_NAME_PARAM,
  );
  const experimentVariations = WindowService.getQueryParamValues(
    EXPERIMENT_VARIATION_PARAM,
  );

  const numOverrides = Math.min(
    experimentNames.length,
    experimentVariations.length,
  );
  const experimentOverrides: Record<string, string> = {};
  for (let i = 0; i < numOverrides; i++) {
    experimentOverrides[experimentNames[i]] = experimentVariations[i];
  }

  return experimentOverrides;
}
